export enum ClinicStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  INACTIVE = 'INACTIVE',
  REVIEW_PENDING = 'REVIEW_PENDING',
}
